// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"AppScreen_appContainer__17nOW"};